var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHt(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d21034",
    d: "M0 0h53.3v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00209f",
    d: "M0 0h53.3v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.4 15H33v10H20.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#016a16",
    d: "m29.2 22.2-2.6.1h-2.5l-1.9.6c-.5.1-.5.3-.9.4l-.5.1-.4.2V25H33v-1.3l-.4-.2-.7-.2c-.4 0-.3-.3-.8-.4-.6 0-1.9-.7-1.9-.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    d: "M26 19.1h.1l.4 1.5-.1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m25.7 18.2.2 1h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    d: "m26 20.6-.5-1.5h.2l.7 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m25.3 18.2.2 1h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    d: "m25.6 20-.3-.7.7 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m24.8 18.5.4 1h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0a328c",
    d: "m25.6 20.2-1.5-1.7c-.5.4-.4 1-.4 1l1.8 1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    d: "m26.5 21-1.1-1c-.5 0-.1.7 0 .8l1.1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    d: "m26.4 21-2.3-2.6H24l2.5 2.8zM24 18.1V18l-.5-.4.2.5zv.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    d: "m23.7 18.4.4-.3v.2l-.2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0a328c",
    d: "m23.4 18.8.1.2.6-.5h.3l.1-.1c-.3-.3-.5 0-.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    d: "m23.7 19 .3-.4q.3.2.5-.2-.3.1-.4 0h-.2v.1l-.4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0a328c",
    d: "m25 20.6-2-1.5c-.3.3 0 1.4 0 1.4l1.9 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    d: "M26.6 21.9 25 20.6c-.6 0-.1.9-.1 1l1.7.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    d: "M26.5 21.6 23 19v.1l3.5 2.8zm-3.6-2.7v-.2l-.6-.2.3.5h.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    d: "m22.7 19.1.3-.3.2.1-.3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0a328c",
    d: "M22.5 19.5v.2l.5-.5h.4V19c-.2-.3-.5.1-.5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    d: "m22.8 19.8.2-.5q.3.2.5-.3H23l-.1.2-.4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0a328c",
    d: "m24.8 21.6-2.4-1.4q-.2.6 0 .8l.1.7q0 .4.4.7c.2.8 1 .9 1.4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    d: "m26.4 22.5-1.6-1c-.6 0 0 1 0 1.2l1.6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    d: "m26.2 22.1-3.8-2 4 2.3zm-4-2.1-.1-.1-.6-.2.4.4h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    d: "m22 20.2.3-.4.2.2-.2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0a328c",
    d: "M21.9 20.7v.2l.5-.7h.3V20c-.2-.3-.4.2-.4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    d: "m22.2 21 .1-.7q.3.2.5-.3-.4.2-.5.1v.2l-.3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    d: "M27.4 19.1h-.2l-.3 1.5v.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m27.6 18.2-.1 1h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    d: "m27.2 20.6.6-1.5h-.2l-.7 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m28 18.2-.2 1h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    d: "m27.7 20 .4-.7h-.2l-.6 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m28.5 18.5-.4 1H28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0a328c",
    d: "m27.7 20.2 1.5-1.7c.5.4.4 1 .4 1L27.9 21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    d: "m26.8 21 1.1-1c.5 0 .1.7.1.8l-1.2 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    d: "m27 21 2.2-2.6h.1L27 21.3zm2.4-2.8V18l.5-.4-.2.5h-.2v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    d: "m29.6 18.4-.3-.3-.2.2.3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0a328c",
    d: "m29.9 18.8-.1.2-.5-.5h-.4v-.1c.2-.3.4 0 .4 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    d: "m29.6 19-.3-.4q-.2.2-.5-.2h.6v.1l.4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0a328c",
    d: "m28.3 20.6 2-1.5c.3.3 0 1.4 0 1.4l-1.8 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    d: "m26.8 21.9 1.5-1.3c.6 0 .2.9.1 1l-1.6.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    d: "m26.8 21.6 3.4-2.6.1.1-3.6 2.8zm3.6-2.7v-.2l.6-.2-.3.5h-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    d: "m30.6 19.1-.3-.3-.2.1.3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0a328c",
    d: "M30.8 19.5v.2l-.5-.5H30l-.1-.2c.2-.3.5.1.5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    d: "m30.5 19.8-.2-.5q-.3.2-.4-.3.3.1.4 0l.1.2.4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0a328c",
    d: "m28.5 21.6 2.5-1.4q.1.6-.1.8l-.1.7q0 .4-.4.7c-.2.8-1 .9-1.4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    d: "m26.9 22.5 1.6-1c.6 0 0 1 0 1.2l-1.6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    d: "m27.2 22.1 3.7-2h.1l-4 2.3zm4-2.1v-.1l.6-.2-.4.4zh-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    d: "m31.3 20.2-.2-.4-.2.2.2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0a328c",
    d: "M31.4 20.7v.2l-.4-.7h-.4V20c.2-.3.4.2.4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    d: "M31 21v-.7q-.3.2-.4-.3.2.2.4.1v.2l.3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#016a16",
    d: "M26.5 16.7V18h.3v-1.2h.4v-.5h-1v.5zm.1-.4c-1-1-1.8-.6-2-.4l.3-.1-.1.2.3-.2v.2l.2-.2v.2q.6.1.8.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6 16.3c-1-1-1.8-.6-2-.4l.3-.1-.1.2.3-.2v.2l.2-.2v.2q.6.1.8.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#016a16",
    d: "M26.4 16.4c-.1-.2-2-.6-2.5 0h.3v.1l.3-.2-.1.2.2-.2v.2l.2-.3v.2l.2-.1v.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4 16.4c-.1-.2-2-.6-2.5 0h.3v.1l.3-.2-.1.2.2-.2v.2l.2-.3v.2l.2-.1v.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#016a16",
    d: "M26.3 16.5c-.5-.4-1.3-.1-1.3-.1q-.8.1-.8.7l.2-.2v.2-.2l.2.2.1-.4v.3l.2-.3h.1v-.1l.2.1h.2v-.2l.1.1h.2l.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3 16.5c-.5-.4-1.3-.1-1.3-.1q-.8.1-.8.7l.2-.2v.2-.2l.2.2.1-.4v.3l.2-.3h.1v-.1l.2.1h.2v-.2l.1.1h.2l.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#016a16",
    d: "M26.2 16.5c-.4 0-1.4.4-1.6.8h.4v-.1.1l.1-.1.1.1.2-.3v.2-.2l.1.2V17l.1.1V17h.2l.4-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2 16.5c-.4 0-1.4.4-1.6.8h.4v-.1.1l.1-.1.1.1.2-.3v.2-.2l.1.2V17l.1.1V17h.2l.4-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#016a16",
    d: "M26.3 16.6c-.5.2-1 .9-.9 1.1q.2-.3.3.1v-.3.2l.1-.3v-.1h.1l.1-.1V17l.4-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3 16.6c-.5.2-1 .9-.9 1.1q.2-.3.3.1v-.3.2l.1-.3v-.1h.1l.1-.1V17l.4-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#016a16",
    d: "m26.3 16.7-.2.3h.1l-.2.2h.2q-.2 0-.3.3l.2-.1-.2.4.2-.1-.2.4.1-.2.1.6V18l.4.3-.2-.4.3.2-.3-.3.3.1-.3-.4.3.1-.2-.4.2.2v-.2l-.2-.2h.2v-.3m-.1 0q-.3.7-.3 1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.3 16.7-.2.3h.1l-.2.2h.2q-.2 0-.3.3l.2-.1-.2.4.2-.1-.2.4.1-.2.1.6V18l.4.3-.2-.4.3.2-.3-.3.3.1-.3-.4.3.1-.2-.4.2.2v-.2l-.2-.2h.2v-.3m-.1 0q-.3.7-.3 1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#016a16",
    d: "M26.7 16.3c1-1 1.8-.6 2-.4l-.3-.1.1.2-.3-.2v.2l-.2-.2.1.2H28l-.6.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7 16.3c1-1 1.8-.6 2-.4l-.3-.1.1.2-.3-.2v.2l-.2-.2.1.2H28l-.6.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#016a16",
    d: "M27 16.4c0-.2 2-.6 2.4 0h-.3v.1l-.2-.2v.2l-.2-.2v.2l-.2-.3v.2l-.2-.1v.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 16.4c0-.2 2-.6 2.4 0h-.3v.1l-.2-.2v.2l-.2-.2v.2l-.2-.3v.2l-.2-.1v.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#016a16",
    d: "M27 16.5c.5-.4 1.3-.1 1.3-.1q.8.1.8.7L29 17l-.1.2V17l-.2.2v-.4l-.1.3-.2-.3-.2-.1v.1H28l-.2-.2v.1h-.1l-.2-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 16.5c.5-.4 1.3-.1 1.3-.1q.8.1.8.7L29 17l-.1.2V17l-.2.2v-.4l-.1.3-.2-.3-.2-.1v.1H28l-.2-.2v.1h-.1l-.2-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#016a16",
    d: "M27.1 16.5a3 3 0 0 1 1.7.8h-.5v-.1.1l-.1-.1v.1l-.3-.3v.2-.2l-.1.2V17v.1l-.2-.1-.5-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1 16.5a3 3 0 0 1 1.7.8h-.5v-.1.1l-.1-.1v.1l-.3-.3v.2-.2l-.1.2V17v.1l-.2-.1-.5-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#016a16",
    d: "M27 16.6c.5.2 1 .9 1 1.1q-.3-.3-.3.1l-.1-.3v.2-.3h-.1v-.1h-.1V17h-.1l-.4-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 16.6c.5.2 1 .9 1 1.1q-.3-.3-.3.1l-.1-.3v.2-.3h-.1v-.1h-.1V17h-.1l-.4-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#016a16",
    d: "m27 16.7.2.3.1.2h-.2q.2 0 .3.3l-.2-.1.2.4-.1-.1.1.4-.1-.2-.1.6V18l-.3.3.1-.4-.3.2.3-.3-.3.1.3-.4-.2.1.1-.4-.2.2.1-.2v-.4h-.1v-.1m.1 0 .4 1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 16.7.2.3.1.2h-.2q.2 0 .3.3l-.2-.1.2.4-.1-.1.1.4-.1-.2-.1.6V18l-.3.3.1-.4-.3.2.3-.3-.3.1.3-.4-.2.1.1-.4-.2.2.1-.2v-.4h-.1v-.1m.1 0 .4 1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    d: "m26.8 22.2.1-1.9V19h-.5v3.3zm-.4-3.2h.5v-.4h-.5zm0-.4h.5l-.1-.3h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    d: "M26.4 18.4h.4V18h-.3zm.4-.4h-.3zm0 4h-.3Zm0-.3h-.4Zm0-.3h-.4Zm.1-.3h-.5Zm0-.3h-.5Zm0-.3h-.6Zm0-.2h-.6Zm0-.3h-.6Zm0-.3h-.6Zm0-.2h-.6Zm0-.3h-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8 22h-.3m.3-.3h-.4m.5-.3h-.5m.5-.3h-.5m.5-.3h-.5m.5-.3h-.6m.6-.2h-.6m.6-.3h-.6m.6-.3h-.6m.6-.2h-.6m.6-.3h-.5m.4-1.2h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0a328c",
    d: "m26.7 15.9-.3-.3.1-.1v-.3c0-.1.5 0 .5.2v.3l-.1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    d: "m26.7 16.7-.1-.2v-.9h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    d: "M26.9 16v-.4l-.4-.2-.1.3h.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#016a16",
    d: "m25.1 21.4-.2-.1h-.3l.3-.1zm0 .2-.2.3q-.3 0-.3-.3v-.2h.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.9 21.5q.2 0 .2-.2h-.5q0 .2.3.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#016a16",
    d: "M24.8 21.5V21h.2v.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#016a16",
    d: "m25.1 21.3-.2.2q-.3 0-.3-.2v.1l.3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    d: "m26.1 23-.9-.3-.4-.7h-1.5v.5l1.3.2.1.2 1.5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#503200",
    d: "M25.2 23.2 23.7 21l-.1.1 1.5 2.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m23.8 21.1-.1-.2h-.2l.1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    d: "m25.3 21.9-3-.3v.4l3 .3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    d: "m22.3 21.5-.1.6h.1l.1-.6zm.5 0v.6-.5m2 .3v.5l.1-.5m.5 0-.1.6h.1v-.3l.2.1.1-.1V22a.1.1 0 0 0-.2 0v-.2zm-1.1.1-.4.5.5-.3zm-1 1.2.4-.5-.6.3zm1-.2-.4-.3.3.5zm-1.2-.8.6.3-.4-.5zm.6-.4v.7h.1l.2-.6zm.2 1.5v-.6h-.2v.6zm.6-.8h-.6v.1l.6.1zm-1.5.2h.6v-.1l-.6-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    d: "m23.7 22.6.2-.1-.2-.2q-.2 0-.2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    fillRule: "evenodd",
    d: "M24.6 22.5q0 .7-1 .8a1 1 0 0 1-.8-.8q0-.8.9-.9a1 1 0 0 1 .9.9m-.2 0a1 1 0 0 1-.7.7 1 1 0 0 1-.7-.7 1 1 0 0 1 .7-.7 1 1 0 0 1 .7.7",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    d: "m24.1 22 .2-.2Zm-1 1.2.2-.2Zm3-1.6.2.8h-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.2 22 .2-.2m-1.1 1.4.2-.2m2.9-1.4.1.8h-.1l-.1-.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m26 21.5-.2-.2c-.3.3 0 .3 0 .5l.3-.2h.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.2 21.7v-.3H26v.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    fillRule: "evenodd",
    d: "M25.4 22.3v1l-.2.1.2.1h.2v-.3l.1-.2v-.3q0-.2-.2-.2v-.2m.3.4-.2-.1v.5l.2-.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m24.6 23-.1.1h.1v.2h-.2q.2.3.5.2.2-.2-.2-.5zm0 0v.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6 23.1h-.1V23zq.4.3.2.5-.3.1-.5-.2h.3zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    d: "m22 23-.1-.5Zm.1 0-.2-.4Zm.4 0-.5-.3Zm.2-.1-.8-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22 23-.1-.5m.2.5-.2-.4m.6.3-.5-.2m.7.2-.8-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    d: "M21.4 22.1H21v.2l-.6.1.5-.1V22h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#503200",
    d: "m21.8 22.4-.7-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    d: "m22.4 23-.5-.5v-.2l-.2.1v.1zm1.9.7v-.2zm-.3-.2v-.2zm-.3.1v-.1zm-.7.2v-.2zm-.2 0v-.2zm-.2 0v-.2zm.1-.2v-.2zm.2 0v-.2zm.1 0v-.2zm0-.2v-.2zm-.2 0v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    fillRule: "evenodd",
    d: "M24.9 23.7h-.1zh1.5v.1h-.8a.1.1 0 0 1-.2 0h-.6m.4 0h-.1zm.5 0h-.1zm.4 0v.1",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    d: "m27.2 23 1-.3.3-.7H30v.5l-1.3.2-.1.2-1.4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#503200",
    d: "m28.2 23.2 1.5-2.2v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m29.5 21.1.2-.2h.1v.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    d: "m28 21.9 3-.3v.4l-3 .3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    d: "m31 21.5.1.6H31zm-.5 0v.6-.5m-2 .3v.5l-.1-.5zm-.4 0v.6H28v-.3l-.2.1-.1-.1.1-.1h.1v-.2zm1 .1.5.5-.6-.3zm1 1.2-.4-.5.6.3zm-1-.2.4-.3-.3.5zm1.2-.8-.5.3.3-.5zm-.6-.4v.7h-.1l-.2-.6zm-.1 1.5v-.6l.2.6zm-.7-.8h.6v.1l-.6.1zm1.5.2h-.6v-.1l.6-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    d: "m29.6 22.6-.1-.1.1-.2q.2 0 .2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    fillRule: "evenodd",
    d: "M28.7 22.5q0 .7 1 .8a1 1 0 0 0 .8-.8q0-.8-.9-.9a1 1 0 0 0-.9.9m.2 0a1 1 0 0 0 .7.7 1 1 0 0 0 .7-.7 1 1 0 0 0-.7-.7 1 1 0 0 0-.7.7",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    d: "M30.2 22h.1Zm-1 0-.1-.2Zm-.3 1h.2Zm1.3.2L30 23Zm-3-1.6-.2.8h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2 22h.1m-1.1 0-.1-.2m-.2 1.2h.2m1 .2V23m-3-1.4v.8l.2-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m27.2 21.5.4-.2v.5l-.4-.2H27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.1 21.7v-.3h.2v.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    fillRule: "evenodd",
    d: "M27.9 22.3v1l.2.1-.2.1h-.2l.1-.2v-.1h-.1l-.1-.2v-.3q0-.2.2-.2v-.2m-.2.4h.2v.2l-.2.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m28.7 23 .1.1q-.2 0-.2.2h.3q-.2.3-.5.2-.2-.2.3-.5m0 0v.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7 23.1h.1V23zq-.5.3-.3.5.3.1.5-.2h-.3zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    d: "m31.3 23 .2-.5Zm-.1 0 .2-.4Zm-.4 0 .5-.3Zm-.2-.1.9-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.3 23 .2-.5m-.3.5.2-.4m-.6.3.5-.2m-.7.2.9-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    d: "M32 22.1h.3v.2l.6.1-.5-.1V22h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#503200",
    d: "m31.6 22.4.6-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    d: "m30.9 23 .6-.5v-.2l.1.1v.1l-.5.5zm-1.9.7v-.2zm.2-.2v-.2zm.4.1v-.1zm.7.2v-.2zm.2 0v-.2zm.3 0v-.2zm-.1-.2v-.2zm-.3 0v-.2zm-.2 0v-.2zm.1-.2v-.2zm.2 0v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    fillRule: "evenodd",
    d: "M28.5 23.7H27v.1h.7a.1.1 0 0 0 .2 0h.6m-.3 0h.1m-.2 0h.1zm-.5 0h.1m-.3 0h.1m-.1 0v.1",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0a328c",
    d: "M26.6 22q-.5 0-.6.4l.7.2.5-.1v-.1q0-.3-.6-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    d: "M27.3 22.4v1l-.6.1q-.6 0-.7-.2v-.9l.6.2q.6 0 .7-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    d: "M26 22.4v.1l.3 1 .3-.8.2.8.2-.7.3.5V23l-.3-.5-.2.6-.2-.5-.3.5-.2-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0a328c",
    d: "M27.3 23.2v.1q0 .3-.6.2t-.7-.2v-.1l.6.2q.6 0 .7-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    d: "M26.9 23.3h-.2v.2h.2zm-.6 0v.2h.1zm-.3-.1v.1l.1.1zm1.3 0H27v.3l.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3 22.4v1l-.6.1q-.6 0-.7-.2v-.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m27.1 22.3-.4.2q-.5 0-.5-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    d: "M26.5 22.4v.2h.2v-.2zm.5 0v.2zm-.7-.3v.2zm.3 0h.1V22m.4 0v.2zm-.9.4v-.2zm1.2 0v-.2H27zm1.2-1.2q.2 0 .3.4l-.3.1-.2.1v-.5zm-.3.4h.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3 21.7h.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    d: "M28.5 21.5v-.2h-.3v.2l.2-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    fillRule: "evenodd",
    d: "M21.9 23.3v.2l-1 .3.1-.2v.1l.3-.3-.5.1h.1l-.3.4.5.2v.2l.5-.2-.4-.2v.1l-.3-.1 1-.3.1.2v-.2h.2v-.2a.1.1 0 0 0-.2 0zm.3.2H22",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    d: "M32.4 23.7v-.3l-.1.1-.1-.5.5.5h-.2l.2.3-.2.3h-.1v-.2l-1-.4-.2-.2h.3zm-1-.2.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.2 24v-.2h-.3v.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m22 24.4-.4-.2c1.7.1 2-.4 2.4-.5q.4.2-.2.2l.1.3s-1.1.6-2.3.3zm7.1-.3v-.3h.4v.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m31.3 24.3.4-.2c-1.9 0-1.4-.3-2.4-.4-.2 0-.4.3.2.2l-.1.3h.3q1 .5 2 .3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.8 23.9v.4s1 .4 2.9.4 2.8-.4 2.8-.4v-.4q.2.2-2.8.3l-3-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "M24 24.3V24zh.2zm.2-.2h.1m.5 0v.3h-.2V24v.2zm0 .3v-.3h.1l.2.3v-.2.3l-.2-.3zm.4.1v-.3zm.1-.1h.3v.2h-.2zm0 0 .1.1h.1v-.2h-.1m.4.2v-.4l.2.3v-.2.3l-.2-.3zm.4 0v-.3h.3-.2v.1h.1-.1zm.3 0v-.3h.1l.2.3zm0-.1h.2v-.1zm.3.1v-.3zm.2 0v-.3h.2-.1zm.4 0v-.3zh.2zm.2 0v-.3h.1l.2.3-.1-.1zm0-.2h.2zm.4.2v-.4h.2-.1v.2h.1-.1zm.3-.2v-.2h.2l.1.1v.1l-.1.1h-.1zm0 0h.2V24H28m.4 0v-.2h.2v.2zm0-.1h.1v-.1h-.1m.5 0h-.2v.2h.2-.2v.2zm.1 0v.2h.2-.2v.1h.2-.2zh.3z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.3v40H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHt);
export default __webpack_public_path__ + "static/media/ht.d209b0d1e17d9c023bcb3aba356b607b.svg";
export { ForwardRef as ReactComponent };